import React from "react";
import { Grid, Typography } from "@material-ui/core";
import Map from "./Map";
import LocationDetails from "./LocationDetails";
const StoreLocation = ({
  classes,
  settings,
  setSettings,
  isValid,
  setIsValid,
}) => {
  return (
    <Grid container direction="row" spacing={5}>
      <Grid item xs={12} className={classes.mt30}>
        <Typography variant="h5" className={classes.typographyStyles}>
          Store Location
        </Typography>
        <hr />
      </Grid>
      <Grid item xs={12} md={6}>
        <Map
          classes={classes}
          settings={settings}
          setSettings={setSettings}
          showHeader={true}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <LocationDetails
          classes={classes}
          settings={settings}
          setSettings={setSettings}
          isValid={isValid}
          setIsValid={setIsValid}
        />
      </Grid>
    </Grid>
  );
};

export default StoreLocation;
